export default __webpack_public_path__ + "static/media/leadingPageSvg.75cc4b79.svg";